"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _classnames = _interopRequireDefault(require("classnames"));

var _reactRouterDom = require("react-router-dom");

var _DynamicBreadcrumbsProvider = require("./DynamicBreadcrumbsProvider");

/**
 * Dynamic breadcrumbs renderer.
 *
 * @function
 * @param {object} props
 * @param {React.ReactElement | string} props.item
 * @param {React.ReactElement | string} [props.finalItem='span']
 * @param {object} [props.itemProps={}]
 * @param {object} [props.finalItemProps={}]
 * @returns {JSX.Element}
 *
 * @example
 * export AwesomePage = () => (
 *  <DynamicBreadcrumbsProvider>
 *    <BreadcrumbItem to="/">Home</BreadcrumbItem>
 *    <main>
 *      <DynamicBreadcrumbs separator=">" item={Link} finalItem="b" />
 *      <FinalBreadcrumb component={Typography} variant="h1" />
 *      Some boring content here...
 *    </main>
 *    <footer>
 *      <DynamicBreadcrumbs />
 *    </footer>
 *  </DynamicBreadcrumbsProvider>
 * );
 */
var DynamicBreadcrumbs = function DynamicBreadcrumbs(_ref) {
  var _ref$item = _ref.item,
      item = _ref$item === void 0 ? _reactRouterDom.Link : _ref$item,
      _ref$finalItem = _ref.finalItem,
      finalItem = _ref$finalItem === void 0 ? 'span' : _ref$finalItem,
      _ref$itemProps = _ref.itemProps,
      itemProps = _ref$itemProps === void 0 ? {} : _ref$itemProps,
      _ref$finalItemProps = _ref.finalItemProps,
      finalItemProps = _ref$finalItemProps === void 0 ? {} : _ref$finalItemProps,
      muiBreadcrumbsProps = (0, _objectWithoutProperties2["default"])(_ref, ["item", "finalItem", "itemProps", "finalItemProps"]);

  var _useBreadcrumbsContex = (0, _DynamicBreadcrumbsProvider.useBreadcrumbsContext)(),
      breadcrumbs = _useBreadcrumbsContex.breadcrumbs;

  return /*#__PURE__*/_react["default"].createElement(_material.Breadcrumbs, muiBreadcrumbsProps, breadcrumbs.filter(function (_ref2) {
    var hidden = _ref2.hidden;
    return !hidden;
  }).map(function (_ref3, index, list) {
    var key = _ref3.key,
        children = _ref3.children,
        to = _ref3.to;
    var isLast = index === list.length - 1;
    var Item = isLast ? finalItem : item;
    var _itemProps$className = itemProps.className,
        itemClassName = _itemProps$className === void 0 ? '' : _itemProps$className,
        otherItemProps = (0, _objectWithoutProperties2["default"])(itemProps, ["className"]);
    var _finalItemProps$class = finalItemProps.className,
        finalItemClassName = _finalItemProps$class === void 0 ? '' : _finalItemProps$class,
        otherFinalItemProps = (0, _objectWithoutProperties2["default"])(finalItemProps, ["className"]);
    return /*#__PURE__*/_react["default"].createElement(Item, (0, _extends2["default"])({
      key: key,
      className: (0, _classnames["default"])((0, _defineProperty2["default"])({}, finalItemClassName, isLast), itemClassName)
    }, otherItemProps, isLast ? otherFinalItemProps : {}, {
      to: to
    }), children);
  }));
};

var _default = DynamicBreadcrumbs;
exports["default"] = _default;